import { useEffect, useState } from "react";
import { ReactComponent as CallIcon } from "./../../assets/images/icons/Google SVGs/call.svg";
import { ReactComponent as LocationOnIcon } from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ChatIcon } from "./../../assets/images/icons/Google SVGs/chat.svg";
import { ReactComponent as StethoscopeIcon } from "./../../assets/images/icons/Google SVGs/stethoscope.svg";
import { ReactComponent as DeleteIcon } from "./../../assets/images/icons/Google SVGs/delete.svg";
import { ReactComponent as AvgPaceIcon } from "./../../assets/images/icons/Google SVGs/avg_pace.svg";
import { ReactComponent as EnhancedEncryptionIcon } from "./../../assets/images/icons/Google SVGs/enhanced_encryption.svg";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";
import { ReactComponent as ScheduleIcon } from "./../../assets/images/icons/Google SVGs/schedule.svg";
import { ReactComponent as DiversityIcon } from "./../../assets/images/icons/Google SVGs/diversity_4.svg";
import { ReactComponent as HomeHealthIcon } from "./../../assets/images/icons/Google SVGs/home_health.svg";
import { ReactComponent as VideoIcon } from "./../../assets/images/icons/Google SVGs/videocam.svg";
import PersianTimePicker from "../DateTimePicker/PersianTimePicker";
import { toast } from "react-toastify";

const visitTimes = [5, 10, 15, 20, 30, 60]

const ShiftFormCard = ({ formId, formData, depPlace, updateForm, removeForm }) => {

  const [departmentPlaces, setDepartmentPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState("");
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [workOnHoliDay, setWorkOnHoliDay] = useState(false);

  const handleUpdateForm = (key, value) => {
    updateForm({ ...formData, [key]: value });
  };

  const handleStartTimeChange = value => {
    const time = value === 'Invalid date' ? '00:00' : value
    handleUpdateForm('start', time)
  };

  const handleEndTimeChange = value => {
    const time = value === 'Invalid date' ? '00:00' : value
    handleUpdateForm('end', time)
  };

  const handlePlaceChange = value => {


    const place = depPlace.find(item => item.place.id == value)

    place?.department?.id && setSelectedDepartment(place.department.id)

    setSelectedPlace(value)

    updateForm({ ...formData, place_id: value, department_id: place.department.id })

    // handleUpdateForm('place_id', value)
    // handleUpdateForm('department_id', place.department.id)

  };

  const handleDepartmentChange = value => {
    setSelectedDepartment(value)
    handleUpdateForm('department_id', value)
  };

  const handleInPersonTypeChange = value => {
    handleUpdateForm('has_in_person', value)
  };

  const handleTextTypeChange = value => {
    handleUpdateForm('has_text', value)
  };

  const handleVoiceTypeChange = value => {
    handleUpdateForm('has_voice_call', value)
  };

  const handleVideoTypeChange = value => {
    handleUpdateForm('has_video_call', value)
  };

  const handleTimePerVisitChange = value => {
    handleUpdateForm('session_time', value)
  };

  const handleIsPrivateChange = () => {
    handleUpdateForm('is_private', !isPrivate)
    setIsPrivate(prev => !prev)
  };

  const uniquePlaces = Array
    .from(new Set(departmentPlaces.map(item => item.place.id)))
    .map(id => departmentPlaces.find(item => item.place.id === id)?.place);

  useEffect(() => {

    const { place_id, start, end, department_id } = formData || {}

    place_id && handlePlaceChange(formData.place_id);
    department_id && handleDepartmentChange(department_id)
    start && handleStartTimeChange(formData.start.substring(0, 5));
    end && handleEndTimeChange(formData.end.substring(0, 5));

  }, [formData?.place_id, formData?.start, formData?.end, formData?.department_id, formId]);

  useEffect(() => {
    if (selectedPlace) {
      const departments = departmentPlaces.filter((item) => item.place.id === parseInt(selectedPlace)).map((item) => item.department);
      setFilteredDepartments(departments);
    } else {
      setFilteredDepartments([]);
    }
  }, [selectedPlace, departmentPlaces]);

  useEffect(() => setDepartmentPlaces(depPlace), [depPlace]);

  return (
    <div className="card w-100 background-bootstrap-gray-100">

      <div className="card-body p-2">

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-link color-bootstrap-regular-danger text-decoration-none p-1"
            onClick={() => removeForm(formId)}
          >
            <DeleteIcon width={24} height={24} className="me-1" />
            حذف
          </button>
        </div>

        <div>
          <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
            <div className="d-flex col col-auto px-0">
              <HomeHealthIcon width={24} height={24} />
            </div>
            <div className="d-flex col px-0">
              <div className="dropdown custom-dropdown w-100 ps-12px">
                <button
                  className="btn dropdown-toggle px-0 pt-0 pb-3 w-100 d-flex text-start border-0 rounded-0 align-items-center color-bootstrap-gray-600"
                  type="button"
                  id={`shift-place-${formId}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedPlace
                    ? uniquePlaces.find(
                      (place) => place.id == selectedPlace
                    )?.title
                    : "مرکز درمانی"}
                  <ChevronDownIcon
                    className="arrow ms-auto"
                    width={24}
                    height={24}
                  />
                </button>
                <ul
                  className="dropdown-menu w-100"
                  aria-labelledby={`shift-place-${formId}`}
                >
                  {
                    uniquePlaces.map((place, index) => (
                      <li key={index}>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handlePlaceChange(place.id)}
                        >
                          {place?.title}
                        </a>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 mt-2 border-bottom">
            <div className="d-flex col col-auto px-0">
              <DiversityIcon width={24} height={24} />
            </div>
            <div className="d-flex col px-0">
              <div className="dropdown custom-dropdown w-100 ps-12px">
                <button
                  className="btn dropdown-toggle px-0 pt-0 pb-3 w-100 d-flex text-start border-0 rounded-0 align-items-center color-bootstrap-gray-600"
                  type="button"
                  id={`shift-department-${formId}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  disabled={!selectedPlace}
                >
                  {
                    selectedDepartment
                      ?
                      filteredDepartments.find(department => department.id === selectedDepartment)?.title || filteredDepartments[0]?.title
                      :
                      "دپارتمان"
                  }
                  <ChevronDownIcon
                    className="arrow ms-auto"
                    width={24}
                    height={24}
                  />
                </button>
                <ul
                  className="dropdown-menu w-100"
                  aria-labelledby={`shift-department-${formId}`}
                >
                  {
                    filteredDepartments.map((department, index) => (
                      < li key={index} >
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleDepartmentChange(department.id)}
                        >
                          {department?.title}
                        </a>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Add other form fields as needed */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom mt-3 mb-1">
          <div className="d-flex col col-auto px-0">
            <ScheduleIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="form-group w-100 ms-12px pb-3">
              <label className="mb-3" htmlFor={`shift-time-${formId}`}>
                ساعت کاری
              </label>
              <div
                className="d-flex row gx-2"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="d-flex col col-6">
                  <PersianTimePicker
                    label="ساعت شروع"
                    value={formData.start ?? null}
                    onChange={handleStartTimeChange}
                  />
                </div>
                <div className="d-flex col col-6">
                  <PersianTimePicker
                    label="ساعت پایان"
                    value={formData.end ? formData.end : null}
                    onChange={handleEndTimeChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* type of visit */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
          <div className="d-flex col col-auto px-0">
            <StethoscopeIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="d-flex row w-100 pb-3 mx-0 ms-2 gx-3 gy-2">
              <div className="d-flex col col-12 px-0 mb-12px justify-content-start">
                <span className="fs-16 fw-normal">نوع ویزیت</span>
              </div>
              <div className="d-flex col col-6 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_in_person ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => handleInPersonTypeChange(!formData.has_in_person)}
                >
                  <LocationOnIcon width={20} height={20} className="me-2" />
                  <span>حضوری</span>
                </span>
              </div>
              <div className="d-flex col col-6 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_voice_call ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => handleVoiceTypeChange(!formData.has_voice_call)}
                >
                  <CallIcon width={20} height={20} className="me-2" />
                  <span>تلفنی</span>
                </span>
              </div>
              <div className="d-flex col col-6 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_text == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => handleTextTypeChange(!formData.has_text)}
                >
                  <ChatIcon width={20} height={20} className="me-2" />
                  <span>متنی</span>
                </span>
              </div>
              <div className="d-flex col col-6 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_video_call == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => handleVideoTypeChange(!formData.has_video_call)}
                >
                  <VideoIcon width={20} height={20} className="me-2" />
                  <span>ویدئویی</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* time per visit */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
          <div className="d-flex col col-auto px-0">
            <AvgPaceIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="d-flex row w-100 pb-3 mx-0 ms-2 gx-3 gy-2">
              <div className="d-flex col col-12 px-0 mb-12px justify-content-start">
                <span className="fs-16 fw-normal">زمان هر ویزیت</span>
              </div>
              {
                visitTimes.map(val =>
                  <div key={val} className="d-flex col col-4 ps-0 cursor-pointer">
                    <span
                      className={`
                        ${formData.session_time === val ? "active" : ""} 
                        d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-12px fs-14 fw-normal w-100 justify-content-center align-items-center`
                      }
                      onClick={() => handleTimePerVisitChange(val)}
                    >
                      <span>{val} دقیقه</span>
                    </span>
                  </div>
                )
              }
              {/*<div className="d-flex col col-12 px-0 flex-column">*/}
              {/*  <span*/}
              {/*    className={`*/}
              {/*      ${!visitTimes.includes(formData.session_time) ? "active" : ""}*/}
              {/*      d-flex btn-blue-check rounded-pill py-2px border border-1 tw-transition-all px-2 fs-14 fw-normal w-100 justify-content-center align-items-center tw-cursor-pointer`*/}
              {/*    }*/}
              {/*    onClick={() => handleTimePerVisitChange(0)}*/}
              {/*  >*/}
              {/*    <span>زمان دلخواه</span>*/}
              {/*  </span>*/}
              {/*  <div className={`${visitTimes.includes(formData.session_time) ? 'tw-hidden' : ''} input-group mt-2`}>*/}
              {/*    <input*/}
              {/*      type="text"*/}
              {/*      className="form-control"*/}
              {/*      placeholder="زمان بر حسب دقیقه"*/}
              {/*      onChange={event => {*/}
              {/*        const value = event.target.value;*/}
              {/*        if (isNaN(+value) || value?.length > 3) {*/}
              {/*          toast.error('زمان یک عدد و حداکثر سه رقم است.')*/}
              {/*          handleUpdateForm('session_time', '')*/}
              {/*          return;*/}
              {/*        }*/}
              {/*        handleTimePerVisitChange(event.target.value)*/}
              {/*      }}*/}
              {/*      value={formData.session_time || ""}*/}
              {/*    />*/}
              {/*    <span className="input-group-text" id="basic-addon2">*/}
              {/*      دقیقه*/}
              {/*    </span>*/}
              {/*  </div>*/}
              {/*</div>*/}

            </div>
          </div>
        </div>

        <div className="d-flex row form-check gap-2 ps-0 mt-3 mx-0 color-bootstrap-gray-600">

          <div className="tw-flex tw-items-center tw-justify-between">

            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="d-flex col col-auto px-0">
                <EnhancedEncryptionIcon width={24} height={24} />
              </div>
              <label className="fs-16 fw-normal" htmlFor="isPrivate">
                نوبت‌دهی خصوصی
              </label>
            </div>

            <div className="form-check form-switch d-flex align-items-center ms-auto">
              <input
                className="form-check-input m-0"
                type="checkbox"
                role="switch"
                id="isPrivate"
                checked={isPrivate}
                onChange={handleIsPrivateChange}
              />
            </div>

          </div>

          <span className="d-flex py-0 fs-14 fw-normal w-100 color-bootstrap-gray-700 align-items-center">
            درصورت فعال بودن ، فقط منشی و پزشک میتوانند نوبت‌دهی را انجام
            دهند
          </span>

        </div>

        <span className="tw-block tw-w-full tw-h-px tw-bg-[#CED4DA] tw-rounded-full tw-my-4"></span>

        <div className="d-flex row form-check gap-2 ps-0 mt-3 mx-0 color-bootstrap-gray-600">

          <div className="tw-flex tw-items-center tw-justify-between">

            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="d-flex col col-auto px-0 tw-size-6">
                <img src="./work_on_holiday.png" alt="work_on_holiday.png" />
              </div>
              <label className="fs-16 fw-normal" htmlFor="onHoliday">
                فعالیت در تعطیلات
              </label>
            </div>

            <div className="form-check form-switch d-flex align-items-center ms-auto">
              <input
                className="form-check-input m-0"
                type="checkbox"
                role="switch"
                id="onHoliday"
                checked={workOnHoliDay}
                onChange={() => {
                  setWorkOnHoliDay(prev => !prev)
                  updateForm({ ...formData, work_on_holidays: Number(Boolean(!workOnHoliDay)) })
                }}
              />
            </div>

          </div>

          <span className="d-flex py-0 fs-14 fw-normal w-100 color-bootstrap-gray-700 align-items-center">
            در ایام تعطیل رسمی (بین هفته) مایل به فعالیت هستم
          </span>

        </div>

      </div>
    </div >
  );
};

export default ShiftFormCard;
